module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-content-item"
  }, [_c('div', {
    staticClass: "box-content-item-user"
  }, [_c('div', {
    staticClass: "nav"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('button', {
      key: index,
      class: index === _vm.navListIndex ? 'nav-item' : 'nav-item1',
      on: {
        "click": function($event) {
          return _vm.handleNav(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "user-list"
  }, _vm._l((_vm.userList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box-content-item-user-item"
    }, [_c('div', {
      staticClass: "box-content-item-user-item-left"
    }, [_c('img', {
      staticClass: "box-content-item-user-item-left-img",
      attrs: {
        "src": item.headPortrait,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "box-content-item-user-item-left-content"
    }, [_c('div', {
      staticClass: "box-content-item-user-item-left-content-name"
    }, [(item.isAnchor == 1) ? _c('img', {
      attrs: {
        "src": require("../assets/images/guan.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.nickName))])]), _vm._v(" "), _c('span', {
      staticClass: "box-content-item-user-item-left-content-span"
    }, [_vm._v("ID:" + _vm._s(item.recodeCode))])])]), _vm._v(" "), _c('div', {
      staticClass: "box-content-item-user-item-box"
    }, [(_vm.navListIndex == 0 && item.isAnchor != 1 && item.isForbidComment == 0) ? _c('button', {
      staticClass: "box-content-item-user-item-box-btn1",
      on: {
        "click": function($event) {
          return _vm.addForbid(item.userId, 3)
        }
      }
    }, [_vm._v("禁止评论")]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 0 && item.isAnchor != 1 && item.isForbidComment == 1) ? _c('button', {
      staticClass: "box-content-item-user-item-box-btn",
      on: {
        "click": function($event) {
          return _vm.relieveForbid(item.userId, 3)
        }
      }
    }, [_vm._v("允许评论")]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 0 && item.isAnchor != 1 && item.isForbidBuy == 0) ? _c('button', {
      staticClass: "box-content-item-user-item-box-btn1",
      on: {
        "click": function($event) {
          return _vm.addForbid(item.userId, 1)
        }
      }
    }, [_vm._v("禁止购买")]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 0 && item.isAnchor != 1 && item.isForbidBuy == 1) ? _c('button', {
      staticClass: "box-content-item-user-item-box-btn",
      on: {
        "click": function($event) {
          return _vm.relieveForbid(item.userId, 1)
        }
      }
    }, [_vm._v("允许购买")]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 0 && item.isAnchor != 1) ? _c('button', {
      staticClass: "box-content-item-user-item-box-btn1",
      on: {
        "click": function($event) {
          return _vm.addForbid(item.userId, 2)
        }
      }
    }, [_vm._v("禁止访问")]) : _vm._e(), _vm._v(" "), (_vm.navListIndex == 1 && item.isAnchor != 1) ? _c('button', {
      staticClass: "box-content-item-user-item-box-btn",
      on: {
        "click": function($event) {
          return _vm.relieveForbid(item.userId, 2)
        }
      }
    }, [_vm._v("允许访问")]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "box-content-container"
  }, [_c('div', {
    staticClass: "box-content-container-title"
  }, [_vm._v("直播大屏")]), _vm._v(" "), (_vm.data) ? _c('div', {
    staticClass: "zhiboxiangqing"
  }, [_c('img', {
    staticClass: "zhiboxiangqing-img",
    attrs: {
      "src": _vm.data.coverUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "zhiboxiangqing-span"
  }, [_vm._v(_vm._s(_vm.data.roomName))]), _vm._v(" "), _c('div', {
    staticClass: "zhibozhong"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/renshu@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data.roomStatus === 1 ? '直播中' : '已结束'))])]), _vm._v(" "), _c('span', {
    staticClass: "zhiboxiangqing-span1"
  }, [_vm._v("开播时间：" + _vm._s(_vm.data.beginTime))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-data"
  }, [_c('div', {
    staticClass: "chengjiao"
  }, [_c('span', {
    staticClass: "chengjiao-span"
  }, [_vm._v("直播间成交金额")]), _vm._v(" "), _c('span', {
    staticClass: "chengjiao-span1"
  }, [_vm._v("US" + _vm._s(_vm.liveInData.orderPaySumAmount ? _vm.liveInData.orderPaySumAmount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list"
  }, [_c('div', {
    staticClass: "box-data-list-box"
  }, [_c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("实时在线")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.viewUserNum ? _vm.liveInData.viewUserNum : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("观看人次")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.viewUserCount ? _vm.liveInData.viewUserCount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("新增用户")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.adduserNum ? _vm.liveInData.adduserNum : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("峰值在线人数")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.onlineNum ? _vm.liveInData.onlineNum : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("评论人数")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.commentNum ? _vm.liveInData.commentNum : 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-box"
  }, [_c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("点赞次数")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.giveCount ? _vm.liveInData.giveCount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("总订单数")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.orderCount ? _vm.liveInData.orderCount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("商品浏览次数")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.goodsViewCount ? _vm.liveInData.goodsViewCount : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  }, [_c('span', {
    staticClass: "box-data-list-item-span"
  }, [_vm._v("成交观众数")]), _vm._v(" "), _c('span', {
    staticClass: "box-data-list-item-span1"
  }, [_vm._v(_vm._s(_vm.liveInData.orderUserNum ? _vm.liveInData.orderUserNum : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "box-data-list-item"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "goods"
  }, [_c('div', {
    staticClass: "goods-list"
  }, _vm._l((_vm.goodsList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "goods-list-item"
    }, [_c('div', {
      staticClass: "goods-list-item-top"
    }, [_c('div', {
      staticClass: "goods-list-item-top-img"
    }, [_c('img', {
      staticClass: "goods-list-item-top-img-img",
      attrs: {
        "src": item.masterImg[0],
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "paixu"
    }, [_vm._v(_vm._s(item.sort))]), _vm._v(" "), (item.isExplain == 1) ? _c('div', {
      staticClass: "jiangjiezhong"
    }, [_c('img', {
      attrs: {
        "src": require("../assets/images/renshu@2x.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v("讲解中")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "goods-list-item-top-content"
    }, [_c('div', {
      staticClass: "goods-name"
    }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('div', {
      staticClass: "goods-price"
    }, [_c('span', {
      staticClass: "goods-price-span"
    }, [_vm._v("US" + _vm._s(item.price))])]), _vm._v(" "), _c('div', {
      staticClass: "goods-dingshi"
    }, [(item.taskListedTime) ? _c('span', [_vm._v("定时上架时间:" + _vm._s(item.taskListedTime))]) : _vm._e(), _vm._v(" "), (item.taskShelvesTime) ? _c('span', [_vm._v("定时下架时间:" + _vm._s(item.taskShelvesTime))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "goods-list-item-btn"
    }, [_c('span', {
      staticClass: "goods-price-span1"
    }, [_vm._v("库存：" + _vm._s(item.inventory))]), _vm._v(" "), _c('div', {
      staticClass: "goods-list-item-btn-box"
    }, [_c('button', {
      staticClass: "goods-list-item-btn-btn1",
      on: {
        "click": function($event) {
          return _vm.handleUpdateKc(item)
        }
      }
    }, [_vm._v("库存")]), _vm._v(" "), _c('button', {
      staticClass: "goods-list-item-btn-btn",
      on: {
        "click": function($event) {
          return _vm.updateGoodsSort(item.dbRecordId, 0)
        }
      }
    }, [_vm._v("上移")]), _vm._v(" "), _c('button', {
      staticClass: "goods-list-item-btn-btn",
      on: {
        "click": function($event) {
          return _vm.updateGoodsSort(item.dbRecordId, 1)
        }
      }
    }, [_vm._v("下移")]), _vm._v(" "), (item.goodsStatus == 2 || item.goodsStatus == 3) ? _c('button', {
      staticClass: "goods-list-item-btn-btn",
      on: {
        "click": function($event) {
          return _vm.updateGoodsStatus(item.dbRecordId, 1)
        }
      }
    }, [_vm._v("上架")]) : _vm._e(), _vm._v(" "), (item.goodsStatus == 1) ? _c('button', {
      staticClass: "goods-list-item-btn-btn",
      on: {
        "click": function($event) {
          return _vm.updateGoodsStatus(item.dbRecordId, 2)
        }
      }
    }, [_vm._v("下架")]) : _vm._e(), _vm._v(" "), (item.goodsStatus == 1 || item.goodsStatus == 2) ? _c('button', {
      staticClass: "goods-list-item-btn-btn",
      on: {
        "click": function($event) {
          return _vm.updateGoodsStatus(item.dbRecordId, 3)
        }
      }
    }, [_vm._v("售罄")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "goods-list-item-btn-btn2",
      on: {
        "click": function($event) {
          return _vm.handleUpdateDssj(item)
        }
      }
    }, [_vm._v("定时上架")]), _vm._v(" "), _c('button', {
      staticClass: "goods-list-item-btn-btn2",
      on: {
        "click": function($event) {
          return _vm.handleUpdateDsxj(item)
        }
      }
    }, [_vm._v("定时下架")]), _vm._v(" "), _c('button', {
      staticClass: "goods-list-item-btn-btn",
      on: {
        "click": function($event) {
          return _vm.handleDelete(item)
        }
      }
    }, [_vm._v("移除")]), _vm._v(" "), (item.isExplain == 0) ? _c('button', {
      staticClass: "goods-list-item-btn-btn1",
      on: {
        "click": function($event) {
          return _vm.updateGoodsExplanationStatus(item.dbRecordId, 1)
        }
      }
    }, [_vm._v("讲解")]) : _vm._e(), _vm._v(" "), (item.isExplain == 1) ? _c('button', {
      staticClass: "goods-list-item-btn-btn1",
      on: {
        "click": function($event) {
          return _vm.updateGoodsExplanationStatus(item.dbRecordId, 0)
        }
      }
    }, [_vm._v("取消")]) : _vm._e()])])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "box-content-video"
  }, [_c('div', {
    staticClass: "video-container"
  }, [_c('img', {
    staticClass: "video-bg-img",
    attrs: {
      "src": _vm.data.coverUrl,
      "alt": "视频背景图"
    }
  }), _vm._v(" "), _c('div', {
    ref: "remoteVideo",
    staticClass: "remote-video",
    attrs: {
      "id": "remote-video"
    }
  })]), _vm._v(" "), _c('div', {
    ref: "danmuContainer",
    staticClass: "danmu"
  }, _vm._l((_vm.msgList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "danmaku-body-item"
    }, [_c('el-dropdown', {
      on: {
        "command": _vm.handleCommand
      }
    }, [_c('div', {
      staticClass: "danmaku-body-item-box"
    }, [(item.sendUserInfo && item.sendUserInfo.isAnchor == 1) ? _c('span', {
      staticClass: "guanliyuan"
    }, [_vm._v("管理员")]) : _vm._e(), _vm._v(" "), (item.sendUserInfo) ? _c('span', {
      staticClass: "danmaku-body-item-box-text"
    }, [_vm._v(_vm._s(item.sendUserInfo.nickName) + "：")]) : _vm._e(), _vm._v(" "), (item.sendUserInfo && item.type != 10) ? _c('span', {
      staticClass: "danmaku-body-item-box-text1"
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (!item.sendUserInfo && item.type != 10) ? _c('span', {
      staticClass: "danmaku-body-item-box-text2"
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (item.sendUserInfo && item.type == 10) ? _c('span', {
      staticClass: "danmaku-body-item-box-text3"
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()]), _vm._v(" "), _c('el-dropdown-menu', {
      attrs: {
        "slot": "dropdown"
      },
      slot: "dropdown"
    }, [_c('el-dropdown-item', {
      attrs: {
        "icon": "el-icon-edit",
        "command": {
          data: item,
          type: 3
        }
      }
    }, [_vm._v("\n\t\t\t\t\t      禁止评论\n\t\t\t\t\t    ")]), _vm._v(" "), _c('el-dropdown-item', {
      attrs: {
        "icon": "el-icon-edit",
        "command": {
          data: item,
          type: 1
        }
      }
    }, [_vm._v("\n\t\t\t\t\t      禁止购买\n\t\t\t\t\t    ")]), _vm._v(" "), _c('el-dropdown-item', {
      attrs: {
        "icon": "el-icon-edit",
        "command": {
          data: item,
          type: 2
        }
      }
    }, [_vm._v("\n\t\t\t\t\t      禁止访问\n\t\t\t\t\t    ")])], 1)], 1)], 1)
  }), 0)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改库存",
      "visible": _vm.openK,
      "width": "600px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.openK = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.formK.specificationList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "规格名称",
      "align": "center",
      "prop": "specificationName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格(元)",
      "align": "center",
      "prop": "price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存",
      "align": "center",
      "prop": "inventory"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "placeholder": "请输入库存"
          },
          model: {
            value: (scope.row.inventory),
            callback: function($$v) {
              _vm.$set(scope.row, "inventory", $$v)
            },
            expression: "scope.row.inventory"
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitFormK
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.openK = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改定时上架时间",
      "visible": _vm.open2,
      "width": "500px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.open2 = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form2,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "定时上架时间",
      "prop": "time"
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:00 - 23:59:59'
      },
      "placeholder": "定时上架时间",
      "value-format": "HH:mm:ss"
    },
    model: {
      value: (_vm.form2.time),
      callback: function($$v) {
        _vm.$set(_vm.form2, "time", $$v)
      },
      expression: "form2.time"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm2
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.open2 = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改定时下架时间",
      "visible": _vm.open3,
      "width": "500px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.open3 = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form3,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "定时下架时间",
      "prop": "time"
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:00 - 23:59:59'
      },
      "placeholder": "定时下架时间",
      "value-format": "HH:mm:ss"
    },
    model: {
      value: (_vm.form3.time),
      callback: function($$v) {
        _vm.$set(_vm.form3, "time", $$v)
      },
      expression: "form3.time"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm3
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.open3 = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94908a4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/zhibodaping.vue
// module id = 831
// module chunks = 1